import { render } from "./WorkflowDeleteItemDialog.vue?vue&type=template&id=bf556b06"
import script from "./WorkflowDeleteItemDialog.vue?vue&type=script&lang=js"
export * from "./WorkflowDeleteItemDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__